// Legal Disclaimer Types
export type LegalDisclaimerProps = {
  header: string;
  description: Array<{
    text: string;
    url?: string;
    stylings?: Array<string>;
  }>;
};

// Premium Coverage Types
export type PremiumCoverage = {
  premiumCoverageId: number | string;
  premium: number;
  coverage: number;
  premiumCoverageTypeId?: number;
  isPremiumFullyPaid?: boolean;
};

// Constants
export const REQUIRE_SECURITY_DEPOSIT = 'REQUIRE_SECURITY_DEPOSIT';
export const WAIVE_SECURITY_DEPOSIT = 'WAIVE_SECURITY_DEPOSIT';

export const RENT_GUARANTEE_LISTING_STATE = {
  NOT_ENROLLED: 'notEnrolled',
  PENDING: 'pending',
  WILL_ACTIVATE: 'willActivate',
  ACTIVE: 'active',
  ACTIVE_RENEW: 'activeRenew',
  EXPIRED: 'expired',
  PENDING_CANCELLATION: 'pendingCancellation',
  CANCELLED: 'cancelled',
  COVERAGE_REQUEST_SIGNED: 'coverageRequestSigned',
  COVERAGE_REQUEST_SIGNING_CANCELLED: 'coverageRequestSigningCancelled',
  PENDING_ACTIVATION: 'pendingActivation',
  MISSING_PAYMENT_METHOD: 'missingPaymentMethod',
  DROPPED: 'dropped',
  HIDE: 'hide',
  REVIEWING_ZRM_TOOLS_AND_SECURITY_DEPOSIT: 'reviewingZrmToolsAndSecurityDeposit',
  LIGHTWEIGHT_OPT_IN: 'lightweightOptIn',
  SUNSET: 'sunset',
} as const;
